import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, NgForm, FormGroup, FormArray, FormControl } from '@angular/forms';
import { FileScheduleState, JurisDictionCode, Hash, FileDescription, ClientFileScheduleAndContractInfoModel } from '@core/services/client/client.model';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as filescheduleActions from "../state/fileschedule_state/fileschedule.actions";
import * as fromFileSchedule from "../state/fileschedule_state/fileschedule.reducer";
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ClientfileschedulesService } from '@core/services/client/clientfileschedules.services';
import { TimeCompareAsyncValidator } from '../../components/clientid-async-validator';
import { AuthService } from '@core/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'Teranet-Clientfileschedules',
  templateUrl: './clientfileschedules.component.html',
  styleUrls: ['./clientfileschedules.component.scss']
})

export class ClientfileschedulesComponent implements OnInit {
  @Input() Readonly: boolean;
  @Input() ClientId: number;

  FileSchedulesFormGroup: FormGroup;
  fileschedules7: FormGroup;

  clientfileschedulearray = new FormArray([]);
  clientcontractinfoarray = new FormArray([]);
  clientserialcollateraltypeinfoarray = new FormArray([]);
  selectedFileSchedule$: Observable<ClientFileScheduleAndContractInfoModel>;
  fileschedule: ClientFileScheduleAndContractInfoModel;
  filedescriptions: FileDescription[];
  processstatuses: Hash[];
  Jurisdictioncodes: JurisDictionCode[];
  jurisdictioncodes: string[];
  urgencys: Hash[];
  impacts: Hash[];
  filestatuses: Hash[];

  selectedFiledescriptionData: any;
  selectedprocessstatusesData: any;
  selectedjurisdictioncodesData: any;

  selectedfilestatusesnData: any;
  
  Isshow = false;

  constructor(public loader: LoadingBarService, private toastrService: ToastrService, private auth: AuthService, private store: Store<FileScheduleState>,
    private clientfileschedulesService: ClientfileschedulesService,
   private route: ActivatedRoute) {
    //console.log("clientid", this.ClientId);

    this.FileSchedulesFormGroup = new FormGroup({
      clientfilescheduleiInfolist: this.clientfileschedulearray
    });
  }

  newclientfileschedule(): FormGroup {
    return new FormGroup({
      id: new FormControl(0),
      clientfileinfoid: new FormControl('', [Validators.required]),
      expectedstarttime: new FormControl(''),
      filenamechecktime:new FormControl(''),
      expectedtime: new FormControl(''),
      expectedtimetext: new FormControl(''),
      expectedresettime: new FormControl(''),
      processstatusid: new FormControl(0),
      filestatusid: new FormControl(0),
      runonsun: new FormControl(false),
      runonmon: new FormControl(false),
      runontue: new FormControl(false),
      runonwed: new FormControl(false),
      runonthu: new FormControl(false),
      runonfri: new FormControl(false),
      runonsat: new FormControl(false),
      isenabled: new FormControl(true),
      createemail: new FormControl(false),
      isemailpriority: new FormControl(false),
      createincident: new FormControl(false),
      urgency: new FormControl('', [Validators.required, Validators.max(3), Validators.min(1)]),
      impact: new FormControl('', [Validators.required, Validators.max(3), Validators.min(1)])
    });
  }

 
  formControlValueChanged(i: number) {

    const expectedresettimeControl = this.clientfileschedulearray.controls[i].get('expectedresettime');

    this.clientfileschedulearray.controls[i].get('expectedresettime').valueChanges.subscribe(
      (mode: string) => {
        console.log('mode', mode);
        expectedresettimeControl.setValidators(TimeCompareAsyncValidator(this.clientfileschedulearray.controls[i].get('expectedstarttime').value));
        expectedresettimeControl.updateValueAndValidity({ emitEvent: false });
      });

    this.clientfileschedulearray.controls[i].get('expectedstarttime').valueChanges.subscribe(
      (mode: string) => {
        console.log('mode', mode);
        expectedresettimeControl.setValidators(TimeCompareAsyncValidator(this.clientfileschedulearray.controls[i].get('expectedstarttime').value));
        expectedresettimeControl.updateValueAndValidity({ emitEvent: false });
      });

  }

  ngOnInit() {

    this.loader.increment(50);
    this.loader.start();
    this.route.queryParams.subscribe(value => {
      if (value) {
        if (value['id'] as number >= 0) {
          this.ClientId = value['id'] as number;
        }
        else {
          this.ClientId = -1;
        }
      }
    });

    if (this.ClientId > 0) {
      this.refesh();

      setTimeout(() => {
        this.loader.complete();
      }, 2800);


    }
    else {
      this.loader.complete();
      this.Isshow = true;
    }
  }

  Checking() {
    if (this.fileschedule) {
      if (!this.fileschedule.clientfilescheduleiInfolist) {
        this.fileschedule.clientfilescheduleiInfolist = [];
      }

      if (this.clientfileschedulearray.length == 0) {
        for (var file in this.fileschedule.clientfilescheduleiInfolist) {
          this.clientfileschedulearray.push(this.newclientfileschedule());
        }
      }

    }
  }

  refesh() {

    this.store.dispatch(new filescheduleActions.LOADFILESCHEDULE(this.ClientId));
    this.selectedFileSchedule$ = this.store.pipe(select(fromFileSchedule.getCurrentFileSchedule));
    this.selectedFileSchedule$.subscribe(fileschedule => {
      this.fileschedule = fileschedule as ClientFileScheduleAndContractInfoModel;
      this.Checking();
      if (this.fileschedule) {
        this.FileSchedulesFormGroup.patchValue({ ... this.fileschedule });

        if (this.fileschedule.clientfilescheduleiInfolist) {
          for (var i = 0; i < this.clientfileschedulearray.length; i++) {
            this.formControlValueChanged(i);
          }
        }
      }
      this.Isshow = true;
    });
  }

  createClientFileSchedule(form: NgForm) {
    if (this.FileSchedulesFormGroup.valid) {
      const neweFileSchedule: ClientFileScheduleAndContractInfoModel = {
        id: this.ClientId,
        lastupdatedby: this.auth.currentUserValue.username,
        clientfilescheduleiInfolist: this.FileSchedulesFormGroup.get("clientfilescheduleiInfolist").value
      }
      console.log("neweFileSchedule", neweFileSchedule);
      if (this.ClientId > 0) {
        this.store.dispatch(new filescheduleActions.UPDATEFILESCHEDULE(neweFileSchedule));
      }
      else {
        this.store.dispatch(new filescheduleActions.CREATEFILESCHEDULE(neweFileSchedule));
      }
      this.fileschedule = null;
    }
    else {
      this.toastrService.error("Please check each File Schedule , there has error.");
    }
  }
}
